var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoImgFound(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 39,
    viewBox: "0 0 40 39",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.97559 26L14.4275 18.5481C15.6967 17.2789 17.7545 17.2789 19.0237 18.5481L26.4756 26M23.2256 22.75L25.8025 20.1731C27.0717 18.9039 29.1295 18.9039 30.3987 20.1731L32.9756 22.75M23.2256 13H23.2418M10.2256 32.5H29.7256C31.5205 32.5 32.9756 31.0449 32.9756 29.25V9.75C32.9756 7.95507 31.5205 6.5 29.7256 6.5H10.2256C8.43066 6.5 6.97559 7.95507 6.97559 9.75V29.25C6.97559 31.0449 8.43066 32.5 10.2256 32.5Z",
    stroke: "#A6A8AC",
    strokeWidth: 3.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImgFound);
export default __webpack_public_path__ + "static/media/NoImgFound.65ba293250d27b6271073a185325a31a.svg";
export { ForwardRef as ReactComponent };